"use client";

import Link from "next/link";
import dynamic from "next/dynamic";
import type { ComponentProps } from "react";

import type BlogBackNavTemplate from "@/components/layout/BlogBackNav";
import { ReadableCopy, readableFallback } from "@/components/readable";

const BlogBackNav = dynamic(() => import("@/components/layout/BlogBackNav"), {
  ssr: false,
  loading: readableFallback(),
});

export default function ClientOnlyBlogBackNav(
  props: ComponentProps<typeof BlogBackNavTemplate>,
) {
  return (
    <ReadableCopy
      copy={
        <p>
          <Link href="/blog/">{props.label ?? "Blog"}</Link>
        </p>
      }
    >
      <BlogBackNav {...props} />
    </ReadableCopy>
  );
}
